import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardHeader,
    CardFooter,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    DropdownToggle,
    Col,
    Pagination,
    PaginationItem,
    PaginationLink,
    Table,
    Container,
    Row,
    Alert,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    FormGroup,
    FormFeedback,
    Form
} from "reactstrap";

import Header from "components/Headers/Header.js";
import { useDispatch, useSelector } from "react-redux";
import { listCategory } from "store/actions/admin";
import Spinner from "components/Spinner/Spinner";
import CustomModal from "components/Modal";
import { addEditCategory, modalReset } from "store/actions/admin";
import { blockUnblockCategory } from "store/actions/admin";
import { content } from "config/content";

const Category = () => {
    const dispatch = useDispatch();
    //redux state
    const isLoading = useSelector(state => state.admin.loading);
    const isError = useSelector(state => state.admin.error);
    const categories = useSelector(state => state.admin.category.data);
    const totalCount = useSelector(state => state.admin.category.count);
    const isModalLoading = useSelector(state => state.admin.modalLoading);
    const modalError = useSelector(state => state.admin.modalError);
    const modalMessage = useSelector(state => state.admin.modalMessage);

    //local state
    const [modal, setModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [categoryName, setCategoryName] = useState('');
    const [categoryId, setCategoryId] = useState(null);
    const [isCategoryValid, setIsCategoryValid] = useState(false);
    const [categoryStatus, setCategoryStatus] = useState(null);
    const [isTouched, setIsTouched] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [limitPerPage,] = useState(25);


    //fetch listing on first render
    useEffect(() => {
        dispatch(listCategory());
    }, [dispatch]);

    //fetch updated list
    useEffect(() => {
        dispatch(listCategory(
            searchQuery ? searchQuery : null,
            (limitPerPage * currentPage),
            limitPerPage));
        resetModal();
    }, [modalMessage, dispatch]);

    //reset modal states
    const resetModal = () => {
        setModal(false);
        setConfirmModal(false);
        setCategoryName('');
        setCategoryId(null);
        setIsCategoryValid(false);
        setCategoryId(null);
        setIsTouched(false);
    }

    //modal open handler
    const toggleModal = () => {
        if (modal) {
            resetModal();
        } else
            setModal(true);
    }

    //Confirm modal open handler
    const toggleConfirmModal = () => {
        if (confirmModal) {
            resetModal();
        } else
            setConfirmModal(true);
    }

    //new category handler
    const addNewHandler = () => {
        dispatch(modalReset());
        setIsEdit(false);
        toggleModal();
    }

    //save category
    const saveCategoryHandler = () => {
        dispatch(addEditCategory(categoryId, categoryName));
    }

    //validate category name
    const onCategoryNameChange = e => {
        setCategoryName(e.target.value);
        setIsTouched(true);
        if (e.target.value.length <= 25 && e.target.value.length >= 3) {
            setIsCategoryValid(true);
        } else
            setIsCategoryValid(false);
    }

    //edit category button 
    const editCategoryHandler = (id, name) => {
        setCategoryId(id);
        setCategoryName(name);
        setIsEdit(true);
        toggleModal();
    }

    //search category
    const searchHandler = e => {
        e.preventDefault();
        setCurrentPage(0);
        if (searchQuery)
            dispatch(listCategory(searchQuery));
        else
            dispatch(listCategory());
    }

    //show block unblock confirm modal
    const blockUnblockHandler = (id, currentStatus) => {
        setCategoryStatus(currentStatus);
        setCategoryId(id);
        setConfirmModal(true);
    }

    //update the category status
    const blockConfirmHandler = () =>
        dispatch(blockUnblockCategory(categoryId, 1 - categoryStatus));

    const handlePageClick = (e, index) => {
        e.preventDefault();
        setCurrentPage(index);
        dispatch(listCategory(
            searchQuery ? searchQuery : null,
            (limitPerPage * index),
            limitPerPage
        ));
    };


    return (
        <>
            <Header />
            {/* Page content */}
            <Container className="mt--7" fluid>
                < Row >
                    <div className="col">
                        <Card className="shadow">
                            {isLoading ?
                                <Spinner />
                                :
                                isError ?
                                    <h5 style={{ color: 'red' }}>{isError}</h5>
                                    :
                                    <>
                                        <CardHeader className="border-0">
                                            <Row className="align-items-center">
                                                <Col >
                                                    <Form onSubmit={searchHandler}>
                                                        <InputGroup size="sm">
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className="fas fa-search" />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input
                                                                placeholder={content.searchbarPlaceholder}
                                                                type="text"
                                                                value={searchQuery}
                                                                onChange={e => setSearchQuery(e.target.value)}
                                                            />
                                                        </InputGroup>
                                                    </Form>
                                                </Col>
                                                <Col xs="8" className="text-right">
                                                    <Button
                                                        onClick={addNewHandler}
                                                        color="primary"
                                                        size="sm"
                                                    >
                                                        Add New
                                        </Button>
                                                </Col>
                                            </Row>
                                        </CardHeader>
                                        <Table className="align-items-center table-flush" responsive>
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col">Actions</th>
                                                    <th scope="col">Sr. No.</th>
                                                    <th scope="col">Category Name</th>
                                                    <th scope="col">Created at</th>
                                                    <th scope="col">Status</th>
                                                    
                                                    {/* <th scope="col" /> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {categories.map((category, i) => {

                                                    return (
                                                        <tr key={category._id}>

                                                            <td >
                                                                <UncontrolledDropdown>
                                                                    <DropdownToggle
                                                                        className="btn-icon-only "
                                                                        role="button"
                                                                        href="#w"
                                                                        size="sm"
                                                                        color=""
                                                                        onClick={e => e.preventDefault()}
                                                                    >
                                                                        <i className="fas fa-cog " />
                                                                    </DropdownToggle>
                                                                    <DropdownMenu className="dropdown-menu-arrow" right>
                                                                        <DropdownItem
                                                                            onClick={() =>
                                                                                editCategoryHandler(category._id, category.category_name)
                                                                            }
                                                                        >
                                                                            Edit
                                                                    </DropdownItem>
                                                                        <DropdownItem
                                                                            onClick={() => blockUnblockHandler(category._id, category.status)}
                                                                        >
                                                                            {category.status === 1 ? 'Block' : 'Unblock'}
                                                                        </DropdownItem>
                                                                    </DropdownMenu>
                                                                </UncontrolledDropdown>
                                                            </td>

                                                            <td>{(limitPerPage * currentPage) + (i + 1)}</td>
                                                            <td>{category.category_name}</td>
                                                            <td>{new Date(category.createdAt).toLocaleString()}</td>
                                                            <td>{category.status === 1 ? 'Active' : 'Blocked'}</td>

                                                            
                                                        </tr>
                                                    )
                                                })
                                                }

                                            </tbody>
                                        </Table>
                                        <CardFooter className="py-4">
                                            <nav aria-label="...">
                                                <Pagination
                                                    className="pagination justify-content-end mb-0"
                                                    listClassName="justify-content-end mb-0"
                                                >
                                                    <PaginationItem disabled={currentPage <= 0}>
                                                        <PaginationLink
                                                            onClick={e => handlePageClick(e, currentPage - 1)}
                                                            tabIndex="-1"
                                                        >
                                                            <i className="fas fa-angle-left" />
                                                            <span className="sr-only">Previous</span>
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                    {[...Array(Math.ceil(totalCount / limitPerPage))].map((_, i) => (
                                                        <PaginationItem active={i === currentPage} key={i}>
                                                            <PaginationLink
                                                                onClick={e => handlePageClick(e, i)}
                                                                href="#">
                                                                {i + 1}
                                                            </PaginationLink>
                                                        </PaginationItem>
                                                    ))}
                                                    <PaginationItem disabled={
                                                        (currentPage + 1) >= Math.ceil(totalCount / limitPerPage)
                                                    }>
                                                        <PaginationLink
                                                            onClick={e => handlePageClick(e, currentPage + 1)}
                                                        >
                                                            <i className="fas fa-angle-right" />
                                                            <span className="sr-only">Next</span>
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                </Pagination>
                                            </nav>
                                        </CardFooter>

                                    </>
                            }
                        </Card>

                        {/* add edit category modal */}
                        <CustomModal
                            isOpen={modal}
                            toggle={toggleModal}
                            headerText={isEdit ? 'Edit Category' : 'Add New Category'}
                            primaryBtnText={isEdit ? 'Update' : 'Add'}
                            secondaryBtnText="Cancel"
                            onClick={saveCategoryHandler}
                            isPrimaryDisable={!isCategoryValid}
                        >
                            {isModalLoading ?
                                <Spinner />
                                :
                                <FormGroup>
                                    <Input
                                        invalid={(!isCategoryValid && isTouched)}
                                        placeholder="Enter Category Name"
                                        type="text"
                                        value={categoryName}
                                        onChange={onCategoryNameChange}
                                    />
                                    <FormFeedback>length must be only between 3-25 characters</FormFeedback>
                                    <br />

                                    {modalError &&
                                        <Alert color="danger">{modalError}</Alert>
                                    }
                                </FormGroup>
                            }
                        </CustomModal>

                        {/* block unblock confirm modal */}
                        <CustomModal
                            isOpen={confirmModal}
                            toggle={toggleConfirmModal}
                            headerText={categoryStatus ? 'Block Category' : 'Unblock Category'}
                            primaryBtnText="Confirm"
                            secondaryBtnText="Cancel"
                            onClick={blockConfirmHandler}
                        >
                            Are you sure you want to {categoryStatus ? 'block' : 'unblock'} this category?
                            {modalError &&
                                <Alert color="danger">{modalError}</Alert>
                            }
                        </CustomModal>
                    </div>
                </Row>
            </Container>
        </>
    );
}

export default Category;
